/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-case-declarations */
/* eslint-disable no-return-await */
/* eslint-disable no-useless-return */
/* eslint-disable object-shorthand */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-lonely-if */
/* eslint-disable jsx-a11y/no-access-key */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useState, useEffect } from "react";
import {
  Divider,
  CircularProgress,
  Box,
  Container,
  Typography,
  CardContent,
  Avatar,
  CardHeader,
  Card,
  Button,
  Link,
  Rating,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate, useLocation } from "react-router-dom";
import InfoLine from "../../components/InfoLine";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Dlg from "../../components/Dlg";
import Axios from "../../api/Axios";
import { initTemplateDetail } from "./ITemplateDetail";
import { useParams } from "react-router-dom";
import { getHistorys, postHistory } from "../../api/History";
import { getItem } from "../../utils/nauth";
import {
  getBaseUrl,
  getAccountServerType,
  getTemplatesServerType,
} from "../../constants";
import { observer } from "mobx-react";
import { UtcDateFormatter } from "../../utils/dateformat/dateFormat";
import { StatusColor, StatusText, RejectInfo } from "../../commonObj";
import NoteContainer from "../../components/Users/NoteContainer";
import { DynamicLinks } from "./Modules/DynamicLinks";
import { Moderation } from "../Templates/DetailModule/Moderation";
import { File } from "../Templates/DetailModule/File";
import { DeviceInfo } from "../Templates/DetailModule/DeviceInfo";
import { useStore } from "../../store";
import { useDidMountEffect } from "../../utils/custom";
import { getTemplates } from "../../api/Templates";
import useKeyPress from "../../utils/custom/useKeyPress";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import { TemplatesRequestProps } from "../../api/types";
import {
  setStartFormat,
  setEndFormat,
} from "../../utils/dateformat/dateFormat";
import { Cookies } from "react-cookie";
import { defaultAllCode } from "./LanguageCode";
import moment from "moment";

interface Props {
  handleScrollTo: (top: boolean) => void;
}

dayjs.extend(utc);

const TemplatesDetail = () => {
  const params = new URLSearchParams(window.location.search);
  const {
    TemplatesDetailStore: {
      moderation,
      loadData,
      setModeration,
      moderationStatus,
      mixabilityStatus,
      referenceStatus,
      assetStatus,
      entertainmentStatus,
      recommendedStatus,
      gachaStatus,
      gameStatus,
      languageStatus,
      regionStatus,
      extraDescStatus,
      emptyRegionCheck,
    },
  } = useStore();
  const [isLoading, setLoading] = useState(true);
  const [reviewProgress, setreviewProgress] = useState(false);

  const [openPublishDlg, setPublishOpenDlg] = useState(false);
  const [openRejectDlg, setRejectOpenDlg] = useState(false);
  const [openReviewerDelDlg, setReviewerDelOpenDlg] = useState(false);
  const [openReviewerAssignDlg, setReviewerAssignOpenDlg] = useState(false);
  const [openParentDlg, setParentOpenDlg] = useState(false);
  const [templates, setTemplates] = useState(initTemplateDetail);
  const [noteHistory, setNoteHistory] = useState();
  const [openModerAlert, setModerAlert] = useState(false);
  const [openParentAlert, setParentAlert] = useState(false);
  // const [startReviewer, setStarReviewer] = useState(
  //   params.get("ST") === "true" ? true : false
  // );

  const cookies = new Cookies();
  const getCookie = (item: string) => {
    return cookies.get(item);
  };

  const { templateId } = useParams();
  const userRole = getItem("role");
  const baseUrl = `${getBaseUrl()}/v1/templates`;
  const accountUrl = getAccountServerType();
  const userEmail = getItem("email") || getItem("name") || "No name";
  const [wRatio, setWratio] = useState("");
  const [hRatio, setHratio] = useState("");
  const [openProgress, setOpenProgress] = useState(false);

  // const [reviewStatus, setReviewStatus] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const userLang = navigator.language || "en";
  const [msgSB, setMsgSB] = useState("");
  const [parentId, setParentId] = useState("");

  const config = {
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, Content-Type, Accept",
      "Content-type": "application/json",
    },
  };

  const isUserRole = () => {
    return userRole === "operator" || userRole === "admin";
  };

  const isAdminRole = () => {
    return userRole === "admin";
  };

  const getRatio = (item: string) => {
    const splitRatio = item.split(":");
    setWratio(splitRatio[0]);
    setHratio(splitRatio[1]);
  };

  const getReviewer = async () => {
    const templateUrl = templates.templateId
      ? `${baseUrl}/${templates.templateId}`
      : `${baseUrl}/${templateId}`;
    let reviewer;

    try {
      await Axios("GET", templateUrl)
        .then((data) => {
          reviewer = data.reviewer;
        })
        .catch((err) => {
          console.log("getReviewr Err", err);
        });
    } catch (err) {
      console.log("getReviewer", err);
    }
    return reviewer;
  };

  const handleReviewerAssignBtnYes = async (bChkReviewer: boolean = false) => {
    if (bChkReviewer) {
      const reviewer = await getReviewer();
      if (reviewer !== "") {
        setReviewerAssignOpenDlg(false);
        getTemplated(baseUrl, templateId);
        alert(
          "Someone has changed the template state\n(The review is already in progress.)"
        );
        return;
      }
    }
    // setLoading(true);
    setreviewProgress(true);

    const temp = templates.templateId ? templates.templateId : templateId;

    const raUserName = templates.author.name
      ? templates.author.name
      : location.state.template.author.name;
    const raUserId = templates.author.sub
      ? templates.author.sub
      : location.state.template.author.sub;

    let data: any;

    try {
      await Axios("PATCH", `${baseUrl}/${temp}/reviewer`)
        .then((res) => {
          if (!res) {
            data = {
              action: "Start Review",
              templadteId: temp,
              userName: raUserName,
              userId: raUserId,
              status: "In Review -> Start Review",
            };

            setTimeout(
              () =>
                postHistory(userEmail, data).catch((err) => {
                  console.log("start review err", err);
                }),
              100
            );
          } else {
            data = {
              action: "Start Review",
              templadteId: temp,
              userName: raUserName,
              userId: raUserId,
              status: "Error",
              error: "Start Review (code: " + res.response.status + ")",
            };
            setTimeout(
              () =>
                postHistory(userEmail, data).catch((err) => {
                  console.log("start review err", err);
                }),
              100
            );
          }
        })
        .catch((err) => {
          console.log("Start Review err", err);
          data = {
            action: "Start Review",
            templadteId: temp,
            userName: raUserName,
            userId: raUserId,
            status: "Error",
            Error: err,
          };
          setTimeout(
            () =>
              postHistory(userEmail, data).catch((err) => {
                console.log("start review err", err);
              }),
            100
          );
        });
    } catch (error) {
      console.log("Start Review err", error);
    } finally {
      setTimeout(async () => {
        data = {
          action: "Start Review",
          templadteId: templates.templateId,
          userName: raUserName,
          userId: raUserId,
        };
        await getTemplated(baseUrl, templateId, data);
      }, 500);
      setreviewProgress(false);
      setReviewerAssignOpenDlg(false);
      setModeration(true);
    }
  };

  const handleReviewerDelBtnYes = async () => {
    if ((await getReviewer()) === "") {
      setReviewerDelOpenDlg(false);
      getTemplated(baseUrl, templateId);
      alert(
        "Someone has changed the template state.\n(The reviewer has already been registered.)"
      );

      return;
    }
    // setLoading(true);
    setreviewProgress(true);

    const rdUserName = templates.author.name;
    const rdUserId = templates.author.sub;
    let data: any;

    try {
      await Axios(
        "DELETE",
        `${baseUrl}/${templates.templateId}/reviewer`,
        config
      )
        .then((res) => {
          if (!res) {
            data = {
              action: "Stop Review",
              templadteId: templates.templateId,
              userName: rdUserName,
              userId: rdUserId,
              status: "Start Review -> Stop Review",
            };
            setTimeout(
              () =>
                postHistory(userEmail, data).catch((err) => {
                  console.log("Stop review err", err);
                }),
              100
            );
          } else {
            data = {
              action: "Stop Review",
              templadteId: templates.templateId,
              userName: rdUserName,
              userId: rdUserId,
              status: "Error",
              error: "Stop Review (code: " + res.response.status + ")",
            };
            setTimeout(
              () =>
                postHistory(userEmail, data).catch((err) => {
                  console.log("Stop review err", err);
                }),
              100
            );
          }
        })
        .catch((err) => {
          console.log("Stop Review err", err);
          data = {
            action: "Stop Review",
            templadteId: templates.templateId,
            userName: rdUserName,
            userId: rdUserId,
            status: "Error",
            error: err,
          };
          setTimeout(
            () =>
              postHistory(userEmail, data).catch((err) => {
                console.log("Stop review err", err);
              }),
            100
          );
        });
    } catch (error) {
      console.log("Stop Review err", error);
    } finally {
      setTimeout(async () => {
        data = {
          action: "Stop Review",
          templadteId: templates.templateId,
          userName: rdUserName,
          userId: rdUserId,
        };
        await getTemplated(baseUrl, templateId, data);
      }, 500);
      setreviewProgress(false);
      setReviewerDelOpenDlg(false);
      setModeration(false);
    }
  };

  const handlePublishBtnYes = async () => {
    if (isAdminRole() || templates.reviewer === userEmail) {
      setPublishOpenDlg(false);
      setOpenProgress(true);

      const pId = templates.templateId;
      const pUserName = templates.author.name;
      const pUserId = templates.author.sub;
      const pTemplateArr = [];
      let data: any;

      pTemplateArr.push(pId);

      try {
        let pData = {
          templatesIds: pTemplateArr,
        };
        const startTime = moment().format("YYYY-MM-DD HH:mm:ss");
        await Axios("PATCH", `${baseUrl}/publish`, pData, config)
          .then(async (res) => {
            if (!res) {
              const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
              data = {
                action: "Publish",
                templadteId: pId,
                userName: pUserName,
                userId: pUserId,
                status: templates.reviewStatus + " -> Published",
                // startTime: startTime,
                // endTime: endTime,
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("err", err);
              });
            } else {
              data = {
                action: "Publish",
                templadteId: pId,
                userName: pUserName,
                userId: pUserId,
                status: "Error",
                error:
                  "Publish API call failed(code: " + res.response.status + ")",
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("err", err);
              });
              alert(
                "An error occurred while changing the state. (Publish Err)"
              );
              return;
            }
          })
          .catch((err) => {
            console.log("publishErr", err);
          });
      } catch (err) {
        console.log("error", err);
      } finally {
        data = {
          action: "Publish",
          templadteId: pId,
          userName: pUserName,
          userId: pUserId,
        };
        setTimeout(
          async () => await getTemplated(baseUrl, templateId, data),
          500
        );
        setOpenProgress(false);
      }
    } else {
      setPublishOpenDlg(false);
      alert("You are not a registered reviewer.");

      return;
    }
  };

  const handleRejectBtnYes = async () => {
    if (isAdminRole() || templates.reviewer === userEmail) {
      setRejectOpenDlg(false);
      setOpenProgress(true);

      const rId = templates.templateId;
      const rUserName = templates.author.name;
      const rUserId = templates.author.sub;
      const rTemplateArr = [];
      let data: any;

      rTemplateArr.push(rId);

      try {
        const rData = {
          templatesIds: rTemplateArr,
          rejected: {
            reason: "screening",
            fails: ["video", "image", "file", "description"],
          },
        };

        await Axios("PATCH", `${baseUrl}/reject`, rData, config)
          .then(async (res) => {
            if (!res) {
              data = {
                action: "Reject",
                templadteId: rId,
                userName: rUserName,
                userId: rUserId,
                status: templates.reviewStatus + " -> Rejected",
                rejected: {
                  reason: "screening",
                  fails: ["video", "image", "file", "description"],
                },
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("HistoryErr", err);
              });
            } else {
              data = {
                action: "Reject",
                templadteId: rId,
                userName: rUserName,
                userId: rUserId,
                status: "Error",
                error:
                  "Reject API call failed (code: " + res.response.status + ")",
              };
              await postHistory(userEmail, data).catch((err) => {
                console.log("HistoryErr", err);
              });
              alert("An error occurred while changing the state. (Reject Err)");
              return;
            }
          })
          .catch((err) => {
            console.log("rejectErr", err);
          });
      } catch (err) {
        console.log(err);
      } finally {
        data = {
          action: "Reject",
          templadteId: rId,
          userName: rUserName,
          userId: rUserId,
        };
        setTimeout(
          async () => await getTemplated(baseUrl, templateId, data),
          500
        );
        setOpenProgress(false);
      }
    } else {
      setRejectOpenDlg(false);
      alert("You are not a registered reviewer.");
      return;
    }
  };

  const getTemplated = async (url: string, id: any, sp?: any) => {
    const templateUrl = `${baseUrl}/${id}`;
    let temp: any = null;
    let item = sp || {
      action: "Get Templated",
      templadteId: id,
    };

    try {
      await Axios("GET", templateUrl)
        .then((data) => {
          if (data.response) {
            item = {
              ...item,
              status: "Error",
              error:
                "getTemplated API call failed(code: " +
                data.response.status +
                ")",
            };
            setTimeout(
              () =>
                postHistory(userEmail, item)
                  .catch((err) => {
                    console.log("err", err);
                  })
                  .finally(() => {
                    setLoading(false);
                  }),
              500
            );
            alert("This template does not exist.");
            navigate("/templates");
          } else {
            setTemplates(data);
            getRatio(data.ratios);
            setParentId(data.relation.parentId);
            if (data.reviewer === userEmail) setModeration(true);
            else setModeration(false);
            temp = data;
          }
        })
        .catch((err) => {
          item = {
            ...item,
            status: "Error",
            error: "getTemplated (" + err.response + ")",
          };

          console.log("item", err);
          setTimeout(
            () =>
              postHistory(userEmail, item)
                .then(() => {
                  alert("This template does not exist.");
                })
                .catch((err) => {
                  console.log("err", err);
                })
                .finally(() => {
                  setLoading(false);
                  navigate("/templates");
                }),
            500
          );
        });

      return temp;
    } catch (error) {
      console.log("getTemplated Err", error);
    } finally {
      setLoading(false);
    }
  };

  const getNoteHistory = (id: any) => {
    const startDate = dayjs().subtract(10, "year").toDate();
    const endDate = dayjs().toDate();
    getHistorys(id, startDate, endDate)
      .then((item) => {
        setNoteHistory(item);
      })
      .catch((err) => {
        console.log("NoteErr", err);
      });
  };

  const splitUrl = (templateId: any, url: string, type?: string) => {
    let urlArr = url.split(`${templateId}/`);
    return !type ? urlArr[1] : urlArr[1].replace("reEncoding_", "");
  };

  const originalUrl = (item: string, type: string) => {
    if (item.includes("user_projects_origin")) return item;

    if (type === "video") {
      const url = item
        .replace("user_projects", "user_projects_origin")
        .replace("reEncoding_", "");
      return url;
    } else if (type === "file") {
      const url = item.replace("user_projects", "user_projects_origin");
      return url;
    }
  };

  const filterInspect = (item: any, field: string) => {
    const filterResult = item.filter((i: any) => i.includes(field));
    let result = "";

    if (filterResult.length > 0) result = "reject";
    else result = "pass";

    return result;
  };

  const handleReject = async () => {
    const reviewer = await getReviewer();
    if (emptyRegionCheck) {
      alert("Please select and save a region code, and try it again.");
      return;
    }

    if (reviewer !== "") {
      if (
        (!moderationStatus && mixabilityStatus) ||
        referenceStatus ||
        assetStatus ||
        entertainmentStatus ||
        recommendedStatus ||
        gachaStatus ||
        gameStatus ||
        languageStatus ||
        regionStatus ||
        extraDescStatus
      )
        setModerAlert(true);
      else setRejectOpenDlg(true);
    } else {
      getTemplated(baseUrl, templateId);
      return alert("Please register as a reviewer.");
    }
  };

  const handlePublish = async () => {
    const reviewer = await getReviewer();

    if (emptyRegionCheck) {
      alert("Please select and save a region code, and try it again.");
      return;
    }

    if (reviewer !== "") {
      if (
        (!moderationStatus && mixabilityStatus) ||
        referenceStatus ||
        assetStatus ||
        entertainmentStatus ||
        recommendedStatus ||
        gachaStatus ||
        gameStatus ||
        languageStatus ||
        regionStatus ||
        extraDescStatus
      )
        setModerAlert(true);
      else setPublishOpenDlg(true);
    } else {
      getTemplated(baseUrl, templateId);
      return alert("Please register as a reviewer.");
    }
  };

  const handleStartReview = async () => {
    const reviewer = await getReviewer();
    if (reviewer === "")
      // setReviewerAssignOpenDlg(true);
      handleReviewerAssignBtnYes();
    else {
      getTemplated(baseUrl, templateId);
      alert(
        "Someone has changed the template state\n(The review is already in progress.)"
      );
    }
  };

  const handleDelReview = async () => {
    const reviewer = await getReviewer();
    if (reviewer !== "") handleReviewerDelBtnYes();
    // setReviewerDelOpenDlg(true);
    else {
      getTemplated(baseUrl, templateId);
      alert(
        "Someone has changed the template state.\n(The reviewer has already been registered.)"
      );
    }
  };

  const handleCopyDesc = () => {
    navigator.clipboard.writeText(templates.translations[0].description.trim());
  };

  const handleOK = () => {
    setModerAlert(false);
    setParentAlert(false);
  };

  const handleModerKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "o") {
      if (handleOK) {
        handleOK();
      }
    }
  };

  const handleParentId = (e: any) => {
    setParentId(e.target.value);
  };

  const parentIdAdd = async () => {
    if (!isAdminRole()) {
      alert("You do not have permission. \nPlease contact the administrator.");
      return;
    }

    setParentOpenDlg(false);
    setOpenProgress(true);

    const trimParentID = parentId.trim();
    const userName = templates.author.name
      ? templates.author.name
      : location.state.template.author.name;
    const userId = templates.author.sub
      ? templates.author.sub
      : location.state.template.author.sub;

    let data: any;

    try {
      await Axios(
        "PATCH2",
        `${baseUrl}/${templateId}/parent-id?parentId=${trimParentID}`,
        config
      ).then(async (res) => {
        if (res.status === 200) {
          data = {
            action: "Modify ParentId",
            templadteId: templates.templateId,
            userName: userName,
            userId: userId,
            parentId: parentId,
          };

          setTimeout(
            () =>
              postHistory(userEmail, data).catch((err) => {
                console.log("Modify ParentId err", err);
              }),
            100
          );
        } else if (res.status === 204) {
          data = {
            action: "Modify ParentId",
            templadteId: templates.templateId,
            userName: userName,
            userId: userId,
            parentId: "Null",
          };

          setTimeout(
            () =>
              postHistory(userEmail, data).catch((err) => {
                console.log("Modify ParentId err", err);
              }),
            100
          );
        } else if (res.response.status === 400) {
          data = {
            action: "Modify ParentId",
            templadteId: templates.templateId,
            userName: userName,
            userId: userId,
            parentId: "Not Found Parent Id (" + parentId + ")",
          };

          setTimeout(
            () =>
              postHistory(userEmail, data).catch((err) => {
                console.log("Modify ParentId err", err);
              }),
            100
          );
          setParentAlert(true);
        } else {
          data = {
            action: "Modify ParentId",
            templadteId: templates.templateId,
            userName: userName,
            userId: userId,
            parentId: parentId,
            status: "Error",
            error: "Modify ParentId(code: " + res.response.status + ")",
          };
          setTimeout(
            () =>
              postHistory(userEmail, data).catch((err) => {
                console.log("Modify ParentId err", err);
              }),
            100
          );
        }
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setTimeout(async () => {
        data = {
          action: "Modify ParentId",
          templadteId: templates.templateId,
          userName: userName,
          userId: userId,
        };
        await getTemplated(baseUrl, templateId, data);
      }, 500);
      setOpenProgress(false);
      setParentOpenDlg(false);
      // window.location.reload();
    }
  };

  const handleKeyDown = async (event: KeyboardEvent) => {
    if (!isUserRole()) return;

    if (
      (event.target as HTMLElement)?.tagName !== "TEXTAREA" &&
      (event.target as HTMLElement)?.tagName !== "INPUT" &&
      (event.target as HTMLElement)?.tagName !== "LI" &&
      !openPublishDlg &&
      !openRejectDlg &&
      !openReviewerDelDlg &&
      !openReviewerAssignDlg
    ) {
      switch (event.key) {
        case "s":
          if (templates.reviewStatus === "InReview") handleStartReview();
          break;
        case "d":
          {
            // console.log("press D: ", templates.filePath);
            const fileUrl = templates.filePath;
            const fileName = splitUrl(templateId, templates.filePath, "file");

            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = fileName;
            link.click();
          }
          break;
        case " ":
          {
            // console.log("press F: ", document.getElementById("video"));
            document.getElementById("video")?.focus();
            // const e = new KeyboardEvent("keydown", {
            //   // keyCode: event.key,
            //   key: event.key,
            //   bubbles: true,
            //   cancelable: true,
            // });
            // document.getElementById("video")?.dispatchEvent(e);
          }
          break;
        case "c":
          if (
            event.ctrlKey === false &&
            event.metaKey === false &&
            event.altKey === false &&
            event.shiftKey === false
          )
            handleCopyDesc();
          break;
        case "p":
          if (
            templates.reviewStatus === "InReview" ||
            templates.reviewStatus === "Rejected"
          )
            handlePublish();
          break;
        case "e":
          if (
            templates.reviewStatus === "InReview" ||
            templates.reviewStatus === "Rejected"
          )
            handlePublish();
          break;
        case "r":
          if (
            templates.reviewStatus === "InReview" ||
            templates.reviewStatus === "Published"
          )
            handleReject();
          break;
        case "g":
          event.preventDefault();
          let templateID: string = "";
          let temp: any;

          const requestParameter: TemplatesRequestProps = {
            page: 1,
            display: 100,
            startedAt: setStartFormat(new Date(2023, 4, 1)),
            endedAt: setEndFormat(new Date()),
            reviewStatus: "InReview",
            language: getCookie("language")
              ? getCookie("language").value
              : defaultAllCode.value,
            sort: "asc",
          };

          try {
            await getTemplates(requestParameter)
              .then((data: any) => {
                data.templates.some((template: any) => {
                  if (template !== undefined) {
                    if (template.reviewer === "") {
                      templateID = template.templateId;
                      temp = template;
                      return true;
                    }
                  }
                  return false;
                });

                if (templateID.length && temp) {
                  navigate(`/templates/${templateID}`, {
                    state: {
                      template: temp,
                    },
                  });
                } else {
                  setMsgSB("There are no empty reviewers for 100 templates.");
                }
              })
              .catch((err: any) => {
                console.error(err);
                setMsgSB("getTemplates return Error");
              });
          } catch (error) {
            console.log("error", error);
          } finally {
            window.location.reload();
          }

          break;

        case "q":
          window.location.href = `${getTemplatesServerType()}templates/userid/${
            templates.author.sub
          }`;

          break;
        default:
          console.log("Not Match: ", event.key);
      }
    }
  };

  const scrollToParent = (top: boolean) => {
    document.getElementById("shortkey")?.scrollIntoView(top);
  };

  const autoSizing = () => {
    return {
      width: `${(Number(wRatio) / Number(hRatio)) * 255}px`,
      height: "255px ",
      outline: "none",
    };
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    let temp: any = getTemplated(baseUrl, templateId);
    getNoteHistory(templateId);

    if (location.state?.template && temp) {
      temp.then((data: any) => {
        if (location.state?.template.reviewer === data.reviewer) {
          handleStartReview();
        }
      });
    }
  }, []);

  useEffect(() => {
    if (isLoading === false) document.getElementById("shortkey")?.focus();
  }, [isLoading]);

  useDidMountEffect(() => {
    // setLoading(true);

    const moderData = {
      action: "Moderation",
      userName: templates.author.name,
      userId: templates.author.sub,
      templadteId: templateId,
    };
    getTemplated(baseUrl, templateId, moderData);
  }, [loadData]);

  useKeyPress(["s", "d", " ", "c", "p", "r", "e", "g", "q"], handleKeyDown);

  if (isLoading) {
    return (
      <Container
        sx={{
          mt: "100px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }
  return (
    <Container
      id="shortkey"
      sx={{
        pb: "20px",
        outline: "none",
        ml: "0px",
      }}
      // tabIndex={0}
      // onKeyDown={handleKeyDown}
    >
      <Box sx={{ m: 2, display: "flex", alignItems: "baseline" }}>
        <Typography variant="h6" style={{ minWidth: "101px" }}>
          Template ::
        </Typography>
        <Typography variant="h5" sx={{ ml: 1 }} style={{ minWidth: "53px" }}>
          Detail
        </Typography>
        <Typography
          sx={{ ml: 10, minWidth: "250px" }}
          onClick={() => {
            navigator.clipboard.writeText(templates.templateId);
          }}
        >
          {templates.templateId}{" "}
          <ContentCopyIcon
            sx={{ fontSize: "medium" }}
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigator.clipboard.writeText(templates.templateId);
            }}
          />
        </Typography>
        {/* {isAdminRole() && (
          <>
            <Button
              variant="outlined"
              size="small"
              style={{
                maxHeight: "40px",
                color: "#6750A4",
                borderColor: "#6750A4",
              }}
              sx={{ ml: 34 }}
              onClick={handleReject}
            >
              <b>
                <u>U</u>
              </b>
              pdate
            </Button>
          </>
        )} */}
        {isUserRole() && templates.reviewStatus === "InReview" ? (
          <>
            <Button
              variant="outlined"
              size="small"
              style={{
                maxHeight: "40px",
                color: "#6750A4",
                borderColor: "#6750A4",
              }}
              sx={{ ml: 49 }}
              onClick={handleReject}
            >
              <b>
                <u>R</u>
              </b>
              eject
            </Button>
            <Button
              variant="outlined"
              size="small"
              style={{
                maxHeight: "40px",
                color: "#6750A4",
                borderColor: "#6750A4",
              }}
              sx={{ ml: 1 }}
              onClick={handlePublish}
            >
              <b>
                <u>P</u>
              </b>
              ublish
            </Button>
          </>
        ) : isUserRole() && templates.reviewStatus === "Published" ? (
          <>
            <Button
              variant="outlined"
              size="small"
              style={{
                maxHeight: "40px",
                color: "#6750A4",
                borderColor: "#6750A4",
              }}
              sx={{ ml: 64 }}
              onClick={() => {
                setRejectOpenDlg(true);
              }}
            >
              <b>
                <u>R</u>
              </b>
              eject
            </Button>
          </>
        ) : isAdminRole() && templates.reviewStatus === "Rejected" ? (
          <Button
            variant="outlined"
            size="small"
            style={{
              maxHeight: "40px",
              color: "#6750A4",
              borderColor: "#6750A4",
            }}
            sx={{ ml: 64 }}
            onClick={handlePublish}
          >
            <b>
              <u>P</u>
            </b>
            ublish
          </Button>
        ) : (
          ""
        )}
      </Box>
      <Card sx={{ m: 2, border: 1 }}>
        <Box sx={{ ml: 5, display: "flex" }}>
          <CardHeader
            avatar={
              <Avatar
                src={
                  templates.author.profileImage
                    ? templates.author.profileImage
                    : ""
                }
              />
            }
            sx={{ pb: "8px" }}
          />
          <CardContent
            sx={{
              pt: "8px",
              pb: "8px !important",
            }}
          >
            <Typography variant="h6" gutterBottom component="div">
              User Name : {templates.author.username}
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              fontWeight={500}
              fontSize="14px"
            >
              Nickname :{" "}
              <Link
                target="_blank"
                href={accountUrl + "/" + templates.author.sub}
              >
                {templates.author.name}
              </Link>
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              fontWeight={500}
              fontSize="14px"
            >
              User ID : {templates.author.sub}
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              fontWeight={500}
              fontSize="12px"
              color={StatusColor[templates.author.status]}
            >
              &bull; {StatusText[templates.author.status]}
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              fontWeight={500}
              fontSize="12px"
            >
              <Link
                href={
                  getTemplatesServerType() +
                  "templates/userid/" +
                  templates.author.sub
                }
              >
                Uploaded Templates (Q)
              </Link>
            </Typography>
          </CardContent>
        </Box>
      </Card>
      <Card sx={{ m: 2, border: 1 }}>
        <Box sx={{ ml: 5, mr: 5, position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              mt: "-10px",
              mb: "-13px",
            }}
            minHeight={75}
          >
            <Box sx={{ m: "20px", mb: "1px" }} width={"30%"}>
              <Typography
                fontSize={"20px"}
                fontWeight={"500"}
                fontFamily={"inherit"}
                lineHeight={"1.334"}
                display={"block"}
              >
                Template Information
              </Typography>
            </Box>
            <Box sx={{ mt: "22px" }} width={"15%"}>
              <Typography color={"#07A499"}>
                <b>
                  {templates.reviewStatus === "InReview"
                    ? "In Review"
                    : templates.reviewStatus}
                </b>
              </Typography>
            </Box>

            <Box sx={{ mt: "22px" }} width={"55%"}>
              <Typography color={"#07A499"}>
                : {reviewProgress ? "In Progress...." : templates.reviewer}
              </Typography>
            </Box>
            {templates.reviewStatus === "InReview" && (
              <Box sx={{ mt: "18.5px", ml: "40px" }}>
                {templates.reviewer ? (
                  templates.reviewer === userEmail || isAdminRole() ? (
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleDelReview}
                      sx={{
                        width: "125px",
                        height: "35px",
                      }}
                      style={{ color: "#6750A4", borderColor: "#6750A4" }}
                    >
                      Reset Review
                    </Button>
                  ) : null
                ) : null}
                {!templates.reviewer && isUserRole() && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleStartReview}
                    sx={{
                      width: "125px",
                      height: "35px",
                    }}
                    style={{ color: "#6750A4", borderColor: "#6750A4" }}
                    accessKey="s"
                  >
                    <b>
                      <u>S</u>
                    </b>
                    tart Review
                  </Button>
                )}
              </Box>
            )}
          </Box>

          <Divider />
          <CardContent>
            <File templates={templates} wRatio={wRatio} hRatio={hRatio} />

            <InfoLine
              leftTxt="Sound"
              rightTxt={
                templates.kineInfo.existAudio
                  ? "Yes"
                  : "No (It has no audio or contains a sound close to silence.)"
              }
            />

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                m: "10px",
                mt: "-10px",
                mb: "-10px",
                pt: "25px",
              }}
              minHeight={60}
            >
              <Box sx={{ width: "24px", mr: "8px" }} />
              <Box width={"30%"}>
                <Typography fontWeight={500}>Template Resource</Typography>
              </Box>
              <Box>
                {templates.kineInfo.complexity ? (
                  <>
                    <Typography>
                      Total:{" "}
                      {templates.kineInfo.complexity?.videoClipCount +
                        templates.kineInfo.complexity?.imageClipCount +
                        templates.kineInfo.complexity?.audioClipCount +
                        templates.kineInfo.complexity?.transitionCount +
                        templates.kineInfo.complexity?.layerVideoCount +
                        templates.kineInfo.complexity?.layerImageCount +
                        templates.kineInfo.complexity?.layerAssetCount +
                        templates.kineInfo.complexity?.layerTextCount +
                        templates.kineInfo.complexity
                          ?.layerHandwritingCount}{" "}
                    </Typography>
                    <Typography>
                      - Clip{" "}
                      {templates.kineInfo.complexity?.videoClipCount +
                        templates.kineInfo.complexity?.imageClipCount +
                        templates.kineInfo.complexity?.audioClipCount +
                        templates.kineInfo.complexity?.transitionCount}
                      : Video(
                      {templates.kineInfo.complexity?.videoClipCount}), Image
                      Clip(
                      {templates.kineInfo.complexity?.imageClipCount}), Audio(
                      {templates.kineInfo.complexity?.audioClipCount}),
                      Transition(
                      {templates.kineInfo.complexity?.transitionCount})
                    </Typography>
                    <Typography>
                      - Layer
                      {templates.kineInfo.complexity?.layerVideoCount +
                        templates.kineInfo.complexity?.layerImageCount +
                        templates.kineInfo.complexity?.layerAssetCount +
                        templates.kineInfo.complexity?.layerTextCount}
                      : Video(
                      {templates.kineInfo.complexity?.layerVideoCount}), Image(
                      {templates.kineInfo.complexity?.layerImageCount}), Asset(
                      {templates.kineInfo.complexity?.layerAssetCount}), Text(
                      {templates.kineInfo.complexity?.layerTextCount}),
                      Handwriting(
                      {templates.kineInfo.complexity?.layerHandwritingCount})
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography>Data not exist</Typography>{" "}
                  </>
                )}
              </Box>
            </Box>
            <Moderation templates={templates} />
            {!moderation && (
              <>
                <Divider sx={{ mt: "-25px" }} />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-10px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />

                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Mixability</Typography>
                  </Box>
                  <Box>
                    <Rating
                      name="read-only"
                      value={templates.scores.mixability}
                      readOnly
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-25px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />

                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Reference</Typography>
                  </Box>
                  <Box>
                    <Rating
                      name="read-only"
                      value={templates.scores.reference}
                      readOnly
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-25px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />

                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Asset</Typography>
                  </Box>
                  <Box>
                    <Rating
                      name="read-only"
                      value={templates.scores.asset}
                      readOnly
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-25px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />

                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Entertainment</Typography>
                  </Box>
                  <Box>
                    <Rating
                      name="read-only"
                      value={templates.scores.entertainment}
                      readOnly
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-25px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />

                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Category</Typography>
                  </Box>
                  <Box>
                    <Typography>
                      {templates.category
                        .filter((e: any) => e !== "Feed")
                        .join(", ")}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-25px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />
                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Language Code</Typography>
                  </Box>
                  <Box>
                    <Typography>{templates.metaLanguageCode}</Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-25px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />

                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Region Code</Typography>
                  </Box>

                  <Box>
                    {templates.metaCountryCode.length >= 249 ? (
                      <Typography>All Country Code</Typography>
                    ) : (
                      <Typography>
                        {templates.metaCountryCode.join(", ")}
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    m: "10px",
                    mt: "-25px",
                    mb: "-10px",
                  }}
                  minHeight={60}
                >
                  <Box sx={{ width: "24px", mr: "8px" }} />

                  <Box width={"30%"}>
                    <Typography fontWeight={500}>Extra Description</Typography>
                  </Box>
                  <Box>
                    <Typography>
                      {templates.extraDescription.description
                        ? templates.extraDescription.description.trim()
                        : templates.extraDescription.description}{" "}
                      {templates.extraDescription.description && (
                        <Link
                          href={`https://translate.google.co.kr/?sl=auto&hl=${userLang}&text=${templates.extraDescription.description
                            .trim()
                            .replaceAll("#", "%23")}`}
                          target="_blank"
                        >
                          <GTranslateIcon
                            sx={{
                              fontSize: "large",
                              cursor: "pointer",
                              color: "#6666ff",
                            }}
                          />
                        </Link>
                      )}
                    </Typography>
                  </Box>
                </Box>
                <Divider />
              </>
            )}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                m: "10px",
                mt: "-260px",
                mb: "0px",
              }}
              minHeight={60}
            >
              <Box sx={{ width: "24px", mr: "8px" }} />
              <Box width={"30%"}>
                <Typography fontWeight={500}>Thumbnail</Typography>
              </Box>
              <Box sx={{ mt: "270px" }}>
                <Typography minWidth={"20%"} maxWidth={650}>
                  <Link href={templates.imagePath}>
                    {splitUrl(
                      templates.templateId,
                      templates.imagePath,
                      "file"
                    )}
                    {" (Raw)"}
                  </Link>
                </Typography>
                <Typography
                  sx={{ bgcolor: "rgb(249,249,249)" }}
                  minWidth={"20%"}
                  maxWidth={650}
                >
                  <Box
                    sx={autoSizing}
                    component="img"
                    src={templates.imagePath}
                  />
                </Typography>
              </Box>
            </Box>

            <InfoLine
              leftTxt="Template ID"
              rightTxt={templates.templateId}
              copy={true}
            />
            <InfoLine
              leftTxt="Project ID"
              rightTxt={
                templates.relation.projectId &&
                templates.relation.projectId !== "null"
                  ? templates.relation.projectId
                  : ""
              }
              copy={templates.relation.projectId ? true : false}
            />

            {/* <InfoLine
              leftTxt="Parent ID"
              rightTxt={
                templates.relation.parentId &&
                templates.relation.parentId !== "null"
                  ? templates.relation.parentId
                  : ""
              }
              copy={templates.relation.parentId ? true : false}
            /> */}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                m: "10px",
                mt: "0px",
                mb: "-15px",
              }}
              minHeight={60}
            >
              <Box sx={{ width: "24px", mr: "8px" }} />
              <Box width={"30%"}>
                <Typography fontWeight={500}>Parent ID</Typography>
              </Box>
              <Box>
                <TextField
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                      width: 350,
                    },
                  }}
                  variant="outlined"
                  value={parentId}
                  onChange={handleParentId}
                />
              </Box>
              &nbsp;
              <ContentCopyIcon
                sx={{ fontSize: "large", cursor: "pointer", color: "6666ff" }}
                onClick={() => {
                  parentId && navigator.clipboard.writeText(parentId);
                }}
              />
              &nbsp;
              <Button
                variant="text"
                onClick={() =>
                  templates.relation.projectId === parentId
                    ? alert(
                        "Project ID and Parent ID are the same. \nPlease check again."
                      )
                    : setParentOpenDlg(true)
                }
              >
                Modify
              </Button>
            </Box>

            <InfoLine
              leftTxt="Parent Template ID"
              rightTxt={
                templates.relation &&
                templates.relation.parentTemplate !== undefined
                  ? templates.relation.parentTemplate.id || ""
                  : ""
              }
              templatesLink={
                templates.relation &&
                templates.relation.parentTemplate !== undefined
                  ? templates.relation.parentTemplate.id
                  : ""
              }
              copy={
                templates.relation &&
                templates.relation.parentTemplate !== undefined
                  ? true
                  : false
              }
            />

            <InfoLine
              leftTxt="Status"
              rightTxt={
                templates.reviewStatus === "InReview"
                  ? "In Review"
                  : templates.reviewStatus === "Preparing"
                  ? "Preparing"
                  : templates.reviewStatus === "Published"
                  ? templates.reviewStatus +
                    " (" +
                    UtcDateFormatter(templates.publishedAt) +
                    ")"
                  : templates.reviewStatus +
                    " (" +
                    UtcDateFormatter(templates.updatedAt) +
                    ")"
              }
            />
            {templates.reviewStatus === "Rejected" ? (
              <>
                <InfoLine
                  leftTxt="Reject Info"
                  rightTxt={
                    templates.rejected.reason +
                    " : " +
                    templates.rejected.fails.join(", ")
                  }
                />
              </>
            ) : (
              ""
            )}

            <DynamicLinks templates={templates} />

            <InfoLine leftTxt="Ratio" rightTxt={templates.ratios} />
            <InfoLine leftTxt="Duration" rightTxt={templates.duration} />
            <InfoLine leftTxt="Clips" rightTxt={templates.clips} />
            <InfoLine
              leftTxt="Project Level"
              rightTxt={templates.projectLevel}
            />
            <InfoLine leftTxt="Asset Level" rightTxt={templates.assetLevel} />

            <InfoLine
              leftTxt="Uploaded Date"
              rightTxt={UtcDateFormatter(templates.createdAt)}
            />
            <InfoLine
              leftTxt="Published Date"
              rightTxt={
                templates.reviewStatus &&
                templates.publishedAt !== "1970-01-01T00:00:00Z"
                  ? UtcDateFormatter(templates.publishedAt)
                  : ""
              }
            />
            <InfoLine
              leftTxt="Rejected Date"
              rightTxt={
                templates.reviewStatus === "Rejected"
                  ? UtcDateFormatter(templates.updatedAt)
                  : ""
              }
            />
            <DeviceInfo userAgent={templates.userAgent} />
            <NoteContainer
              templateId={templates.templateId}
              isOperator={isUserRole()}
              notes={noteHistory}
              historyFunc={getNoteHistory}
            />
          </CardContent>
          {/* <FloatingPageControl
            handleScrollTo={scrollToParent}
          ></FloatingPageControl> */}
        </Box>
        <Dlg
          open={openPublishDlg}
          contentText={"Are you sure you want to publish selected projects?"}
          handleNo={() => {
            setPublishOpenDlg(false);
          }}
          handlePublishYes={handlePublishBtnYes}
          reviewStatus={templates.reviewStatus}
        />
        <Dlg
          open={openRejectDlg}
          contentText={"Are you sure you want to reject selected projects?"}
          handleNo={() => {
            setRejectOpenDlg(false);
          }}
          handleRejectYes={handleRejectBtnYes}
          reviewStatus={templates.reviewStatus}
        />
        <Dlg
          open={openReviewerDelDlg}
          contentText={"Are you sure you want to delete the reviewer?"}
          handleNo={() => {
            setReviewerDelOpenDlg(false);
          }}
          reviewStatus={templates.reviewStatus}
          handleReviewerDelYes={handleReviewerDelBtnYes}
        />
        <Dlg
          open={openReviewerAssignDlg}
          contentText={"Are you sure you want to assign the reviewer?"}
          handleNo={() => {
            setReviewerAssignOpenDlg(false);
          }}
          reviewStatus={templates.reviewStatus}
          handleReviewerAssignYes={() => handleReviewerAssignBtnYes(true)}
        />
        <Dlg
          open={openParentDlg}
          contentText={"Are you sure you want to modify the parentID??"}
          handleNo={() => {
            setParentOpenDlg(false);
          }}
          handleReviewerAssignYes={() => parentIdAdd()}
        />
        <Dialog open={openProgress} PaperProps={{ id: "openedDlg" }}>
          <DialogContent>
            <Box>
              <DialogContentText>
                In Progress... <CircularProgress size={15} />
              </DialogContentText>
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openModerAlert}
          onKeyDown={handleModerKeyDown}
          PaperProps={{ id: "openedDlg" }}
        >
          <DialogContent>
            <Box>
              <DialogContentText>
                Moderation data has not been saved.
                <br />
                Please save it and try again.
                <br /> (The Cancel button reverts the data.)
              </DialogContentText>
              <DialogActions>
                <Button
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setModerAlert(false);
                  }}
                >
                  <b>
                    <u>O</u>
                  </b>
                  K
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openParentAlert}
          onKeyDown={handleModerKeyDown}
          PaperProps={{ id: "openedDlg" }}
        >
          <DialogContent>
            <Box>
              <DialogContentText>
                The Parent ID could not be found.
              </DialogContentText>
              <DialogActions>
                <Button
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setParentAlert(false);
                  }}
                >
                  <b>
                    <u>O</u>
                  </b>
                  K
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
      </Card>

      {/* <FloatingActionButtons /> */}
    </Container>
  );
};
export default observer(TemplatesDetail);
